/* eslint-disable no-plusplus */
import React from 'react';

import { Flex, GridItem, Text } from '@chakra-ui/react';

import useUser from 'stores/useUser';

export default function WelcomeCard() {
  const { user } = useUser();
  return (
    <GridItem
      as={Flex}
      flexDir="column"
      bg="gradient.primary"
      p={6}
      borderRadius={8}
      colSpan={3}>
      <Text
        color="white.default"
        variant="2xLargeSemiBold">
        Bem vindo(a) de volta,
      </Text>
      <Text
        color="white.default"
        variant="2xLargeBold">
        {user?.name}
      </Text>
    </GridItem>
  );
}
